function replaceQuotes(value) {
  return String(value ?? "");
}

const exactMessageKeys = new Map([
  ["Backup file is not a valid JSON object.", "messages.errors.backupFileNotValidJsonObject"],
  ["Backup file is not a wallet-watch profile backup.", "messages.errors.backupFileNotWalletWatchProfileBackup"],
  ["Backup file is missing profile information.", "messages.errors.backupFileMissingProfileInformation"],
  ["Backup file profile name is missing.", "messages.errors.backupFileProfileNameMissing"],
  ["Backup file is missing the years list.", "messages.errors.backupFileMissingYearsList"],
  ["Backup file is missing the budget category list.", "messages.errors.backupFileMissingBudgetCategoryList"],
  ["Backup file is missing the expenses list.", "messages.errors.backupFileMissingExpensesList"],
  ["Backup file does not include any usable year.", "messages.errors.backupFileNoUsableYear"],
  ["Profile data file is not a valid JSON object.", "messages.errors.profileDataFileNotValidJsonObject"],
  ["Profile data file is not valid JSON.", "messages.errors.profileDataFileNotValidJson"],
  ["Profile data file is missing profile information.", "messages.errors.profileDataFileMissingProfileInformation"],
  ["Profile data file profile name is missing.", "messages.errors.profileDataFileProfileNameMissing"],
  ["Profile data file is missing the years list.", "messages.errors.profileDataFileMissingYearsList"],
  ["Profile data file is missing the budget list.", "messages.errors.profileDataFileMissingBudgetList"],
  ["Profile data file is missing the expense list.", "messages.errors.profileDataFileMissingExpenseList"],
  ["Profile data file does not include any usable year.", "messages.errors.profileDataFileNoUsableYear"],
  ["Profile name is required.", "messages.errors.profileNameRequired"],
  ["Profile year is required.", "messages.errors.profileYearRequired"],
  ["The last remaining profile cannot be deleted.", "messages.errors.lastRemainingProfileCannotBeDeleted"],
  ["A replacement active profile could not be found.", "messages.errors.replacementActiveProfileCouldNotBeFound"],
  ["Refusing to replace a non-empty expense set with an empty one.", "messages.errors.refusingToReplaceNonEmptyExpenseSetWithEmptyOne"],
  ["This browser does not support the File System Access directory picker.", "messages.errors.fileSystemAccessDirectoryPickerNotSupported"],
  ["The selected profile has no available year.", "messages.errors.selectedProfileHasNoAvailableYear"],
  ["Expense amount is required.", "messages.errors.expenseAmountRequired"],
  ["Expense date is required.", "messages.errors.expenseDateRequired"],
  ["The selected CSV is empty.", "messages.errors.selectedCsvIsEmpty"],
  ["Could not determine date format from the provided values.", "messages.errors.couldNotDetermineDateFormat"]
]);

const patternLocalizers = [
  {
    pattern: /^Backup format version (.+) is not supported\.$/,
    localize: (t, match) => `${t("messages.errors.backupFormatVersionNotSupported")} ${replaceQuotes(match[1])}.`
  },
  {
    pattern: /^Profile data export version (.+) is not supported\.$/,
    localize: (t, match) => `${t("messages.errors.profileDataVersionNotSupported")} ${replaceQuotes(match[1])}.`
  },
  {
    pattern: /^Profile data import could not resolve category "(.+)" for year "(.+)"\.$/,
    localize: (t, match) => `${t("messages.errors.profileDataImportCouldNotResolveCategory")} "${replaceQuotes(match[1])}" / "${replaceQuotes(match[2])}".`
  },
  {
    pattern: /^Year "(.+)" already exists for profile "(.+)"\.$/,
    localize: (t, match) => `${t("messages.errors.yearAlreadyExistsForProfile")} "${replaceQuotes(match[1])}" / "${replaceQuotes(match[2])}".`
  },
  {
    pattern: /^Expense date year must match the active year "(.+)"\.$/,
    localize: (t, match) => `${t("messages.errors.expenseDateYearMustMatchActiveYear")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Profile "(.+)" could not be activated\.$/,
    localize: (t, match) => `${t("messages.errors.profileCouldNotBeActivated")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Year "(.+)" is not available for profile "(.+)"\.$/,
    localize: (t, match) => `${t("messages.errors.yearNotAvailableForProfile")} "${replaceQuotes(match[1])}" / "${replaceQuotes(match[2])}".`
  },
  {
    pattern: /^Profile "(.+)" could not be found\.$/,
    localize: (t, match) => `${t("messages.errors.profileCouldNotBeFound")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Year "(.+)" could not be archived\.$/,
    localize: (t, match) => `${t("messages.errors.yearCouldNotBeArchived")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Year "(.+)" could not be unarchived\.$/,
    localize: (t, match) => `${t("messages.errors.yearCouldNotBeUnarchived")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Year "(.+)" could not be deleted\.$/,
    localize: (t, match) => `${t("messages.errors.yearCouldNotBeDeleted")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Profile "(.+)" could not be renamed\.$/,
    localize: (t, match) => `${t("messages.errors.profileCouldNotBeRenamed")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Profile "(.+)" could not be deleted\.$/,
    localize: (t, match) => `${t("messages.errors.profileCouldNotBeDeleted")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Profile "(.+)" has no available year\.$/,
    localize: (t, match) => `${t("messages.errors.profileHasNoAvailableYear")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Active profile "(.+)" could not be found for backup export\.$/,
    localize: (t, match) => `${t("messages.errors.activeProfileCouldNotBeFoundForBackupExport")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Duplicate CSV header: "(.+)"$/,
    localize: (t, match) => `${t("messages.errors.duplicateCsvHeader")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Missing required expense columns: (.+)$/,
    localize: (t, match) => `${t("messages.errors.missingRequiredExpenseColumns")} ${replaceQuotes(match[1])}.`
  },
  {
    pattern: /^Invalid expense amount: "(.+)"$/,
    localize: (t, match) => `${t("messages.errors.invalidExpenseAmount")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Invalid expense date: "(.+)"$/,
    localize: (t, match) => `${t("messages.errors.invalidExpenseDate")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Unsupported expense date format: "(.+)"$/,
    localize: (t, match) => `${t("messages.errors.unsupportedExpenseDateFormat")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Invalid expense type: "(.+)"$/,
    localize: (t, match) => `${t("messages.errors.invalidExpenseType")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Unknown expense category on row (\d+): "(.+)"$/,
    localize: (t, match) => `${t("messages.errors.unknownExpenseCategoryOnRow")} ${replaceQuotes(match[1])}: "${replaceQuotes(match[2])}".`
  },
  {
    pattern: /^Invalid budget amount: "(.+)"$/,
    localize: (t, match) => `${t("messages.errors.invalidBudgetAmount")} "${replaceQuotes(match[1])}".`
  },
  {
    pattern: /^Missing required budget columns: (.+)$/,
    localize: (t, match) => `${t("messages.errors.missingRequiredBudgetColumns")} ${replaceQuotes(match[1])}.`
  },
  {
    pattern: /^Duplicate budget category on row (\d+): "(.+)"$/,
    localize: (t, match) => `${t("messages.errors.duplicateBudgetCategoryOnRow")} ${replaceQuotes(match[1])}: "${replaceQuotes(match[2])}".`
  }
];

export function localizeErrorMessage(error, t = (key) => key) {
  if (!(error instanceof Error)) {
    return null;
  }

  const exactKey = exactMessageKeys.get(error.message);
  if (exactKey) {
    return t(exactKey);
  }

  for (const entry of patternLocalizers) {
    const match = error.message.match(entry.pattern);
    if (match) {
      return entry.localize(t, match);
    }
  }

  return error.message;
}
